var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24px/Arrow/Down"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.27373675e-13,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2000773,12.7340806 L10.2235673,17.7105906 C9.83304302,18.1011149 9.19987804,18.1011149 8.80935375,17.7105906 C8.41288223,17.3141191 8.41288223,16.6809541 8.80340652,16.2904298 L13.0915133,12.001 L8.80340652,7.713054 C8.41288223,7.32252971 8.41288223,6.68936473 8.80340652,6.29884044 C9.19987804,5.90236893 9.83304302,5.90236893 10.2235673,6.29289322 L15.2000773,11.2694032 C15.3803193,11.4496452 15.4773726,11.6815739 15.4912374,11.9174786 L15.4912374,12.0860052 C15.4773726,12.3219099 15.3803193,12.5538386 15.2000773,12.7340806 Z",
    id: "Combined-Shape",
    fill: "#333333",
    transform: "translate(12.001742, 12.001742) rotate(90.000000) translate(-12.001742, -12.001742) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.36635627bb5bb4e061f684aa6bc7d8ca.svg";
export { ForwardRef as ReactComponent };